import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { Knob } from "primereact/knob";
import { useCallback, useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";
import PrimeDialog from "../../components/dialog/PrimeDialog";
import { FormInput } from "../../components/FormInput";
import FormNumberInput from "../../components/FormNumberInput";
import NoInfo from "../../components/NoInfo";
import PrimeTableFooter from "../../components/PrimeTableFooter";
import { useEditableFlag } from "../../hooks/useEditableFlag";
import { SystemLoading, checkLoading } from "../../store/loadingStore";
import NumberUtil from "../../utility/NumberUtil";
import { getSubItemsByItemNo } from "../../utility/service/api-service";
import { B2030202Before, getCompanyStatsList, updateS3BucketUsage } from "../../utility/service/statistics-service";
import { checkDpSuccess, getCompanyType } from "../../utility/service/tool-service";
import { addFormValidator } from "../../utility/validate/formValidator";

const CompanyStatsList_Index = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { itemObj, setItemObj, setAction, setCurrentStatus } = useOutletContext();
  const [rows, setRows] = useState([]);
  const [, loading] = useContext(SystemLoading);
  const [companySeq, setCompanySeq] = useState("");
  const [companyLevel, setCompanyLevel] = useState([]);
  const [showInputDialog, setShowInputDialog] = useState(false);
  const [formRule, setFormRule] = useState([]); //表單驗證
  const isEditable = useEditableFlag("B20302");

  const {
    register,
    handleSubmit,
    watch,
    getValues,
    setValue,
    clearErrors,
    control,
    formState: { errors, isValid, isDirty },
  } = useForm({
    defaultValues: {
      keywordSearch: "",
      companyType: "A",
    },
    //錯誤驗證時機
    mode: "all",
  });

  const axios_getCompanyStatsList = useCallback(
    (reqBody, readMore = false) => {
      checkLoading(loading);
      setCurrentStatus({
        companyLevel: reqBody.companyLevel,
      });
      getCompanyStatsList(reqBody)
        .then((res) => {
          if (checkDpSuccess(res)) {
            let data = res?.data?.RespBody?.companyList;
            if (data?.length > 0) {
              setCompanySeq(res.data.RespBody.companyList[res.data.RespBody.companyList?.length - 1].companySeq);

              if (readMore === true) {
                setRows((pre) => {
                  return [...pre, ...data];
                });
              } else {
                setRows((pre) => {
                  return [...data];
                });
              }
            } else {
              if (readMore === false) {
                setRows([]);
              }
            }
          } else {
            if (readMore === false) {
              setRows([]);
            }
          }
        })
        .finally((fin) => {
          checkLoading(loading, false);
        });
    },
    [loading, setCurrentStatus]
  );

  const onSubmit = (data) => {
    let reqBody = {
      keywordSearch: data.keywordSearch,
      companyLevel: data.companyLevel,
      // companySeq: data.companySeq,
    };

    if (data.status !== null && data.status !== "" && data.status !== undefined) {
      reqBody.status = data.status;
    }
    axios_getCompanyStatsList(reqBody);
  };

  const checkKeyDown = (e) => {
    if (e.key === "Enter") e.preventDefault();
  };

  //查詢更多
  const btnReadMore = () => {
    axios_getCompanyStatsList(
      {
        keywordSearch: getValues("keywordSearch"),
        companyLevel: getValues("companyLevel"),
        companySeq: companySeq,
      },
      true
    );
  };

  const editItem = (item, act) => {
    setItemObj(item);
    navigate(act);
    setAction(act);
  };

  const axios_updateS3BucketUsage = (reqBody) => {
    updateS3BucketUsage(reqBody)
      .then((res) => {
        if (checkDpSuccess(res)) {
          return axios_getCompanyStatsList({
            companyLevel: getValues("companyLevel"),
            keywordSearch: getValues("keywordSearch"),
          });
        }
      })
      .finally((fin) => {
        checkLoading(loading, false);
        setShowInputDialog(false);
      });
  };

  useEffect(() => {
    axios_getCompanyStatsList({
      companyLevel: getValues("companyLevel"),
      keywordSearch: getValues("keywordSearch"),
    });

    getSubItemsByItemNo("COMPANY_LEVEL", 35).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.subItems;
        let newArray = data.map((item, index) => {
          return {
            ...item,
            index: index,
          };
        });
        setCompanyLevel(newArray);
      }
    });

    axios_getCreateBefore();
  }, [axios_getCompanyStatsList, getValues]);

  //建立前查詢form 規則
  const axios_getCreateBefore = () => {
    B2030202Before().then((res) => {
      if (checkDpSuccess(res)) {
        let array = [];
        res?.data?.RespBody?.constraints?.forEach((item) => {
          const result = addFormValidator(item?.field, res.data.RespBody.constraints);
          array.push(result);
        });
        setFormRule(array);
      }
    });
  };

  const setValidForm = useCallback(
    (formId) => {
      if (formRule?.length > 0) {
        const tmp = formRule?.find((item) => {
          return Object.keys(item)[0] === formId;
        });
        return tmp ? tmp[formId] : "";
      }
    },
    [formRule]
  );

  const companyLevelNameTemplate = (rowData, props) => {
    if (rowData) {
      switch (rowData?.effectiveType) {
        case "0": //正式
          return (
            <div className="user-avatar-button">
              <span style={{ color: "var(--primary-color)", fontSize: "1rem" }} className="contract-str">
                {t("formal")}
              </span>
            </div>
          );
        case "1": //試用
          return (
            <div className="user-avatar-button">
              <span style={{ color: "var(--gray-400)", fontSize: "1rem" }} className="contract-str">
                {t("trial")}
              </span>
            </div>
          );
        default:
          return null;
      }
    }
  };

  const companyTypeNameTemplate = (rowData, props) => {
    if (rowData) {
      switch (rowData?.companyType) {
        case "A": //廠商
          return (
            <div className="user-avatar-button">
              <span style={{ color: "var(--green-500)", fontSize: "1rem" }} className="contract-str">
                {rowData?.companyTypeName || t("company.a")}
              </span>
            </div>
          );
        case "B": //顧問
          return (
            <div className="user-avatar-button">
              <span style={{ color: "var(--blue-500)", fontSize: "1rem" }} className="contract-str">
                {rowData?.companyTypeName || t("company.b")}
              </span>
            </div>
          );
        case "M": //管理者
          return (
            <div className="user-avatar-button">
              <span style={{ color: "var(--mint-500)", fontSize: "1rem" }} className="contract-str">
                {rowData?.companyTypeName || t("company.m")}
              </span>
            </div>
          );
        default:
          return rowData?.companyTypeName ? (
            <div className="user-avatar-button">
              <span style={{ color: "var(--gray-400)", fontSize: "1rem" }} className="contract-str">
                {rowData.companyTypeName}
              </span>
            </div>
          ) : null;
      }
    }
  };

  const actionBodyTemplate = (rowData, props) => {
    if (rowData) {
      return (
        <>
          <Button
            tooltip={t("button.event")}
            tooltipOptions={{ position: "top" }}
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            onClick={() => {
              editItem(rowData, "detail");
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-eye" />
          </Button>
          <Button
            tooltip={t("updateS3Quota")}
            tooltipOptions={{ position: "top" }}
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            disabled={!isEditable}
            onClick={() => {
              setShowInputDialog(true);
              setItemObj(rowData);
              setValue("s3BucketQuota", rowData.s3BucketQuota);
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-user-pen" />
          </Button>
        </>
      );
    }
  };

  const konbTemplate = (value, max, isExceedLimit = false) => {
    const numericValue = Number(value);
    const numericMax = Number(max) > 0 ? Number(max) : 1;
    const displayValue = numericValue > numericMax ? numericMax : numericValue;
    return (
      <div className="knobTooltipWrapper" style={{ textAlign: "center" }}>
        <Knob
          value={displayValue}
          min={0}
          max={numericMax}
          valueTemplate={``}
          size={30}
          {...(isExceedLimit && displayValue >= numericMax ? { valueColor: "#d41010" } : {})}
          readOnly
        />
        <small>
          {NumberUtil.formatWithCommas(value)} {max && `/ ${NumberUtil.formatWithCommas(max)}`}
        </small>
      </div>
    );
  };

  return (
    <>
      <div className="p-card bg-gray">
        <div className="p-card-body">
          <form
            className="flex flex-wrap align-items-center col-12"
            onSubmit={handleSubmit(onSubmit)}
            onKeyDown={checkKeyDown}
          >
            <div className="grid col-12">
              {getCompanyType() === "M" && (
                <>
                  {/*會員等級*/}
                  <div className="col-12 lg:col-3">
                    <label htmlFor="companyLevel" className="form-label">
                      {t("membershipLevel")}
                    </label>
                    <Controller
                      name="companyLevel"
                      control={control}
                      render={({ field, fieldState }) => (
                        <Dropdown
                          filter
                          showClear
                          optionLabel="subitemName"
                          optionValue="subitemNo"
                          value={field.value}
                          virtualScrollerOptions={{ itemSize: 40 }}
                          defaultValue={""}
                          placeholder={t("plz_chs_all")}
                          name="membershipLevel"
                          control={control}
                          options={companyLevel}
                          className={"w-full"}
                          onChange={(event) => {
                            field.onChange(event.value);
                          }}
                        />
                      )}
                    />
                  </div>
                </>
              )}

              {/*關鍵字*/}
              <div className={"col-12 lg:col-9"}>
                <FormInput
                  register={register}
                  errors={errors}
                  id="keywordSearch"
                  type="text"
                  placeholder={`${t("company_num")}、${t("organName")}`}
                  labelClass="control-label"
                  enterClick={checkKeyDown}
                  labelText={t("keyword")}
                />
              </div>
            </div>
            <div className="col-12 gap-2 flex-all-center">
              <Button disabled={!isValid} type="submit" label={t("button.query")} />
            </div>
          </form>
        </div>
      </div>
      <div className="p-card">
        <div className="p-card-body">
          <DataTable
            scrollable
            resizableColumns
            columnResizeMode="fit"
            className="white-data-table hover-highlight no-shadow"
            value={rows}
            footer={
              rows.length > 0 && <PrimeTableFooter rowDataList={rows} isShowMore={true} btnReadMore={btnReadMore} />
            }
            emptyMessage={<NoInfo panel="table" />}
          >
            <Column frozen alignFrozen="left" field="taxIdNum" header={t("company_num")} />
            <Column
              frozen
              alignFrozen="left"
              field="companyName"
              header={t("organName")}
              style={{
                width: "300px",
                minWidth: "300px",
                maxWidth: "300px",
                whiteSpace: "normal",
                wordBreak: "break-word",
              }}
            />
            <Column field="companyCountryName" header={t("country")} />
            <Column field="companyLevelName" header={t("membershipLevel")} />
            <Column field="companyTypeName" header={t("type")} body={companyTypeNameTemplate} />
            <Column field="effectiveTypeName" header={t("authorizationType")} body={companyLevelNameTemplate} />
            <Column
              header={
                <div className="text-center">
                  {t("cfvReportCount")}
                  <br />
                  <small>
                    ({t("usage")}/{t("quota")})
                  </small>
                </div>
              }
              body={(rowData) => konbTemplate(rowData.cfvReportUsage, rowData.cfvReportQuota, true)}
            />
            <Column
              header={
                <div className="text-center">
                  {t("carbonFootprintCount")}
                  <br />
                  <small>
                    ({t("usage")}/{t("quota")})
                  </small>
                </div>
              }
              body={(rowData) => konbTemplate(rowData.carbonFootprintUsage, rowData.carbonFootprintQuota, true)}
            />
            <Column
              header={
                <div className="text-center">
                  CBAM
                  <br />
                  <small>
                    ({t("usage")}/{t("quota")})
                  </small>
                </div>
              }
              body={(rowData) => konbTemplate(rowData.cbamUsage, rowData.cbamQuota, true)}
            />
            <Column
              header={
                <div className="text-center">
                  {t("place")}
                  <br />
                  <small>
                    ({t("usage")}/{t("quota")})
                  </small>
                </div>
              }
              body={(rowData) => konbTemplate(rowData.placesUsage, rowData.placesQuota, true)}
            />
            <Column
              header={
                <div className="text-center">
                  {t("subAccountCount")}
                  <br />
                  <small>
                    ({t("usage")}/{t("quota")})
                  </small>
                </div>
              }
              body={(rowData) => konbTemplate(rowData.userUsage, rowData.userQuota, true)}
            />
            {/* <Column header={t("cbamCount")} body={(rowData) => konbTemplate(rowData.cbamUsage, rowData.cbamQuota)} /> */}
            <Column
              header={
                <div className="text-center">
                  {t("s3BucketQuota")}
                  <br />
                  <small>
                    ({t("usage")}/{t("quota")})
                  </small>
                </div>
              }
              body={(rowData) => konbTemplate(rowData.s3BucketUsage, rowData.s3BucketQuota, true)}
            />
            <Column
              style={{ minWidth: "130px" }}
              body={actionBodyTemplate}
              header={t("action")}
              frozen
              alignFrozen="right"
            />
          </DataTable>
        </div>
      </div>

      <PrimeDialog
        visible={showInputDialog}
        title={t("updateS3Quota")}
        placeholder={t("enterNumber")}
        onClose={() => {
          setShowInputDialog(false);
          setItemObj({});
          setValue("s3BucketQuota", "npm");
          clearErrors();
        }}
        disabledConfirm={!(isValid && isDirty)}
        bodyTemplate={
          <>
            <label htmlFor="s3BucketQuota" className="form-label required">
              {t("s3BucketQuota")}
            </label>
            <FormNumberInput
              register={register}
              errors={errors}
              type="number"
              id="s3BucketQuota"
              name="s3BucketQuota"
              className="form-control"
              placeholder={t("enterNumber")}
              rules={setValidForm("s3BucketQuota")}
              value={watch("s3BucketQuota")}
              onChange={(e) => {
                setValue("s3BucketQuota", e);
              }}
            />
          </>
        }
        onConfirm={(val) => {
          axios_updateS3BucketUsage({ companySeq: itemObj.companySeq, s3BucketQuota: getValues("s3BucketQuota") });
        }}
      />
    </>
  );
};

export default CompanyStatsList_Index;
